import type { RequestInfo } from '@warp-drive/core/types/request';
import { buildBaseURL, type QueryUrlOptions } from '@warp-drive/utilities';
import { SkipCache } from '@warp-drive/core-types/request';

/**
 * Request builders for auth/session endpoints.
 */

/** Exchanges the current session token for a fresh access_token during silent SAML renewal. */
export function samlTokenExchangeRequest(): RequestInfo {
  const opts: QueryUrlOptions = {
    identifier: { type: 'saml' },
    op: 'query',
    resourcePath: 'saml/token_exchange',
  };
  return {
    url: buildBaseURL(opts),
    method: 'GET',
    cacheOptions: { [SkipCache]: true },
  };
}
